<template>
    <div class="">
        <div class="content content-block">
          <h4 class="title">
            Your Information
            <small>
              <a @click.prevent="toggleAccountModal" href="#">(edit)</a>
            </small>
          </h4>
          <dl class="floated-list">
            <dt>Full name</dt>
            <dd>{{ accountInfo.accountFirstName }} {{ accountInfo.accountLastName }}</dd>
            <dt>email</dt>
            <dd>{{ accountInfo.accountEmailAddress }}</dd>

            <dt>phone</dt>
            <dd>{{ formattedPhoneNumber }}</dd>

            <dt>Password</dt>
            <dd>
              <a @click.prevent="resetPassword" href="#">Reset password</a>
              <font-awesome-icon v-show="isResettingPassword" icon="spinner" spin />
            </dd>
          </dl>
          <div class="is-clearfix"></div>
        </div>

      <account-info-modal v-model="accountInfo" :show.sync="showAccountModal" />
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import AccountInfoModal from '@/components/FormUserInfo-Modal'
import { formatPhoneNumber, digitsFromString } from '@/helpers/phoneNumberFormatter'
import LoginApi from '@/api-interface/login'

export default {
  name: 'AccountInfo',

  data() {
    return {
      showAccountModal: false,
      isResettingPassword: false
    }
  },

  computed: {
    ...mapGetters('user', ['accountInfo', 'isCompanyAdmin']),
    ...mapState('company', ['currentCompanyInfo']),

    formattedPhoneNumber() {
      const digits = this.accountInfo.accountPhones[0] ? this.accountInfo.accountPhones[0].accountPhoneDigits : ''
      return formatPhoneNumber(digitsFromString(digits))
    }
  },

  methods: {
    ...mapActions('user', ['getMyDetails']),

    formatPhoneNumber: formatPhoneNumber,
    digitsFromString: digitsFromString,

    async resetPassword() {
      try {
        this.isResettingPassword = true
        await LoginApi.resetPasswordFlow(this.accountInfo.accountEmailAddress)
        window.alert(
          'A verification email has been sent to your email.\n' +
            'Please follow the instructions in that email to complete the password reset process.'
        )
      } catch (err) {
        console.log('Error trying to rest password.', err)
      } finally {
        this.isResettingPassword = false
      }
    },

    toggleAccountModal() {
      this.showAccountModal = !this.showAccountModal
    }
  },

  components: {
    AccountInfoModal
  }
}
</script>

<style scoped lang="scss">
.title {
  margin-bottom: 15px;

  small {
    font-weight: lighter;
    font-size: 0.7em;
  }
}

dl {
  margin-left: 15px;
}
dt {
  text-transform: capitalize;
}

dt,
dd {
  margin-top: 12px;
}
</style>
